import { useEffect, useState } from "react";
import { useGetDrawingChanges } from "../../../../api/changeHistory";
import { resolveDrawingChangesQueryInput } from "../helpers/versionHistory.helpers";
import { VersionHistoryRecord } from "../types/versionHistory.types";

export function useVersionDrawingChanges(params: {
  record: VersionHistoryRecord | null | undefined;
  ownerId: string | undefined;
  sourceId: string | undefined;
}) {
  const [showAllChanges, setShowAllChanges] = useState(false);

  useEffect(() => {
    setShowAllChanges(false);
  }, [params.record?.id]);

  const queryInput = resolveDrawingChangesQueryInput(params.record ?? null, params.ownerId, params.sourceId);
  const { data, isFetching, isError } = useGetDrawingChanges(
    queryInput ?? { from: null, to: null, sourceId: "", ownerId: "" }
  );

  return {
    changes: data ?? [],
    isLoading: !!queryInput && isFetching,
    isError: !!queryInput && isError,
    showAllChanges,
    toggleShowAllChanges: () => setShowAllChanges(prev => !prev)
  };
}
